import { makeAutoObservable } from "mobx";

export class ProfileStore {
  isOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  reset() {
    this.isOpen = false;
  }
}
